export default __webpack_public_path__ + "static/media/logo.a70eb8ca.svg";